// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".el-form-item[data-v-7388ce07] {\n  display: flex;\n  align-items: center;\n}\n[data-v-7388ce07] .el-form-item__content {\n  flex: 1;\n  margin-left: 20px !important;\n}", ""]);
// Exports
module.exports = exports;
